// extracted by mini-css-extract-plugin
export var rowNumberHeader = "row-number-header_MOwi8SHfcB9VdCQAPhWa";